import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { useMemo, useState, useEffect } from 'react';
import { LocalStorage } from '@lean-body/src/infra';
import { MatchingAssessmentDiagnosisAnswer, MatchingAssessmentDiagnosisStep } from '@lean-body/src/domain';
import { Colors } from '@lean-body/src/view/styles/variables';
import { MatchingAssessmentDiagnosisStepForm } from './matching_assessment_diagnosis_step_form';
import { PageLoading } from './page_loading';
import { MatchingAssessmentDiagnosisInfoStep } from './matching_assessment_diagnosis_info_step';
import { GoalMatchingAssessmentHeader } from '../molecules/goal_matching_assessment_header';
import { matchingAssessmentDiagnosisFlow } from '@lean-body/src/domain/matching_assessment_diagnosis_steps';
export const MATCHING_ASSESSMENT_DIAGNOSIS_VERSION = 1;
export const MatchingAssessmentDiagnosis = ({ config, tracker, onDiagnosisComplete, onBack, progressQuestionCount, initialProgressCurrent, }) => {
    const localStorage = new LocalStorage();
    const [flowItems, setFlowItems] = useState([]);
    const [questionSteps, setQuestionSteps] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(initialProgressCurrent);
    const [answers, setAnswers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [hasTrackedDiagnosisStart, setHasTrackedDiagnosisStart] = useState(false);
    useEffect(() => {
        loadMatchingAssessmentDiagnosisSteps();
    }, []);
    const stepIndexByStepType = useMemo(() => {
        return new Map(questionSteps.map((step, index) => [step.stepType, index]));
    }, [questionSteps]);
    const loadMatchingAssessmentDiagnosisSteps = () => {
        const nextFlowItems = matchingAssessmentDiagnosisFlow.map((item) => item.type === 'step'
            ? { type: 'step', step: new MatchingAssessmentDiagnosisStep(item.step, config) }
            : item);
        const nextQuestionSteps = nextFlowItems
            .filter((item) => item.type === 'step')
            .map((item) => item.step);
        setFlowItems(nextFlowItems);
        setQuestionSteps(nextQuestionSteps);
        const baseAnswers = nextQuestionSteps.map((step) => MatchingAssessmentDiagnosisAnswer.createEmpty(step));
        setAnswers(baseAnswers);
        setIsLoading(false);
    };
    const handleStepComplete = (answer) => {
        const diagnosisStepIndex = stepIndexByStepType.get(answer.stepType);
        if (diagnosisStepIndex === undefined) {
            return;
        }
        const newAnswers = [...answers];
        newAnswers[diagnosisStepIndex] = answer;
        setAnswers(newAnswers);
        // LocalStorageに保存
        localStorage.saveMatchingAssessmentDiagnosisParams(newAnswers);
        handleNext();
    };
    const handleNext = () => {
        if (currentIndex >= flowItems.length - 1) {
            onDiagnosisComplete();
        }
        else {
            const nextIndex = currentIndex + 1;
            const nextItem = flowItems[nextIndex];
            if (!hasTrackedDiagnosisStart && (nextItem === null || nextItem === void 0 ? void 0 : nextItem.type) === 'step') {
                tracker === null || tracker === void 0 ? void 0 : tracker.trackDiagnosisStart();
                setHasTrackedDiagnosisStart(true);
            }
            setCurrentIndex(nextIndex);
        }
    };
    const handleBack = () => {
        if (currentIndex === 0) {
            onBack();
        }
        else {
            setCurrentIndex(currentIndex - 1);
        }
    };
    if (isLoading || !flowItems.length) {
        return React.createElement(PageLoading, null);
    }
    const currentItem = flowItems[currentIndex];
    const isInfoStep = currentItem.type === 'info';
    return (React.createElement("div", { className: css(styles.container, isInfoStep ? styles.containerInfo : styles.containerStep) },
        React.createElement("div", { className: css(styles.innerWrapper) },
            React.createElement(GoalMatchingAssessmentHeader, { onClickBack: handleBack, progressQuestionCount: progressQuestionCount, prgoressCurrent: currentIndex, hideProgress: isInfoStep }),
            isInfoStep ? (React.createElement(MatchingAssessmentDiagnosisInfoStep, { variant: currentItem.variant, onNext: handleNext })) : (React.createElement(MatchingAssessmentDiagnosisStepForm, { step: currentItem.step, currentAnswer: answers[stepIndexByStepType.get(currentItem.step.stepType)], onComplete: handleStepComplete })))));
};
const styles = StyleSheet.create({
    container: {
        position: 'relative',
        width: '100%',
        height: '100vh',
    },
    containerStep: {
        backgroundColor: Colors.White,
    },
    containerInfo: {
        backgroundImage: Colors.BackgroundAi,
    },
    innerWrapper: {
        padding: '16px 24px 0',
    },
});
